export default {
	offer: 'Offers',
	purchases: 'Purchases',
	total: 'Total'
}